import { getMarkRange } from '@tiptap/core'
import { PluginKey } from '@tiptap/pm/state'
import { useEditorState } from '@tiptap/react'
import { BubbleMenu } from '@tiptap/react/menus'
import { useEditor } from '../store/context'

const pluginKey = new PluginKey('wikiLinkBubbleMenu')

export function WikiLinkBubble() {
  const { view, store } = useEditor()

  const state = useEditorState({
    editor: store.ready ? store.editor() : null,
    selector: ({ editor }) => {
      if (!editor || !editor.isActive('wikiLink'))
        return null
      const attrs = editor.getAttributes('wikiLink') as Record<string, unknown>
      const { $from } = editor.state.selection
      const markType = editor.state.schema.marks.wikiLink
      const range = markType ? getMarkRange($from, markType) : null
      const nodeText = range ? editor.state.doc.textBetween(range.from, range.to) : (attrs.page as string) ?? ''
      return { nodeText, attrs }
    },
  })

  if (!store.ready)
    return null

  const editor = store.editor()

  function removeWikiLink() {
    editor.chain().focus().extendMarkRange('wikiLink').unsetMark('wikiLink').run()
  }

  return (
    <BubbleMenu
      editor={editor}
      pluginKey={pluginKey}
      className="tiptap-wiki-link-bubble"
      shouldShow={({ editor: ed }) => !view.sourceMode && ed.isActive('wikiLink')}
    >
      {state && (
        <>
          <span className="bubble-label" title={String(state.attrs.raw ?? '')}>
            {state.nodeText || '[[…]]'}
          </span>
          <span className="bubble-sep" />
          <button
            type="button"
            className="bubble-btn"
            onMouseDown={(e) => {
              e.preventDefault()
              store.openWikiLinkDialog()
            }}
          >
            Edit
          </button>
          <button
            type="button"
            className="bubble-btn bubble-btn--danger"
            onMouseDown={(e) => {
              e.preventDefault()
              removeWikiLink()
            }}
          >
            Remove
          </button>
        </>
      )}
    </BubbleMenu>
  )
}
